import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import BrandLockup from '../BrandLockup';
import iconMenu from '../../assets/icon-menu-btn.svg';
import team from '../../assets/icon-team.svg';
import iconAdminPanel from '../../assets/admin-panel-icon.svg';
import { AiOutlineStock } from 'react-icons/ai';
import { SlSettings } from 'react-icons/sl';
import { IoLogOutOutline } from 'react-icons/io5';
import { IoArrowForwardOutline } from 'react-icons/io5';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../Context/authContext';
import { StyledSideBar } from './SideBar.styles';

const AdminSideBar = () => {
  const [sideBar, setSideBar] = useState(true);

  const navigate = useNavigate();

  const handleSideBar = () => {
    setSideBar(!sideBar);
  };
  const { user, onLogout } = useContextHook(AuthContext, v => ({
    user: v.user,
    onLogout: v.onLogout,
  }));

  useEffect(() => {
    if (sideBar) {
      document.body.classList.add('sidebar-active');
    } else {
      document.body.classList.remove('sidebar-active');
    }
  }, [sideBar]);

  return (
    <>
      <StyledSideBar $sideBar={sideBar}>
        <div className="nav-wrapper">
          <div className="nav-header">
            <div className="logo">
              <BrandLockup to="/dashboard" width={148} />
            </div>
            <div className="icon-wrap">
              <div className="menu-btn" onClick={handleSideBar}>
                <img src={iconMenu} width="26" alt="icon" />
              </div>
            </div>
          </div>
          <div className="scroll-area">
            {user?.plan?.type === 'admin' && (
              <ul className="nav-links flex-grow">
                <li>
                  <NavLink to="/admin-dashboard">
                    <img src={iconAdminPanel} alt="iconAdminPanel" className="icon" />
                    <span className="label">Dashboard</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/users">
                    <img src={team} alt="iconUsers" className="icon" />
                    <span className="label">Users</span>
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink to="/sessions">
                    <img src={iconSessions} alt="iconSessions" className="icon" />
                    <span className="label">Sessions</span>
                  </NavLink>
                </li> */}
              </ul>
            )}

            <ul className="nav-links nav2">
              <li>
                <NavLink to="/admin-settings">
                  <SlSettings className="icon" />
                  <span className="label">Setting</span>
                </NavLink>
              </li>
              <li>
                <NavLink to="/analytics">
                  <AiOutlineStock className="icon" />
                  <span className="label">Analytics</span>
                </NavLink>
              </li>
              <li>
                <button className="btn-logout" onClick={onLogout}>
                  <IoLogOutOutline className="icon" />
                  <span className="label">Logout</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="profile-holder" onClick={() => navigate('/admin-settings')}>
          <div className="profile-img">
            <span className="text">{user?.first_name?.split('')[0]}</span>
          </div>
          <div className="profile-info">
            <span className="name">{user?.first_name}</span>
          </div>
          <IoArrowForwardOutline className="icon-arrow" />
        </div>
      </StyledSideBar>
    </>
  );
};

export default AdminSideBar;
